import { teamComparisonEventsForMetricAtom } from '@/atoms/queries/team/teamEventDataComparison';
import { PreviewEvents, TEAM_PREVIEW_EVENT_KEYS } from '@/components/tables/PreviewEvents';

export const TeamComparisonPreviewEvents = () => (
  <PreviewEvents eventsAtom={teamComparisonEventsForMetricAtom} eventKeys={TEAM_PREVIEW_EVENT_KEYS} />
);
